import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { BidLineItemType, IBidLineItemResponse } from "@miplatform/types";
import { IBidLineItemPayload } from "../../views/Estimating/Pricing/Customers/CustomerPricingDetails/CustomerPricingDetails.types";

export const useBidLineItems = () => {
  const [bidLineItems, setBidLineItems] = useState<IBidLineItemResponse[]>([]);

  const stateManager = useComponentState();

  const getBidLineItems = async (
    accountId: string,
    bidLineItemType: BidLineItemType | null = null
  ) => {
    return stateManager.run(async () => {
      const response = await homeService.bidLineItems.getByAccountId({
        accountId,
        bidLineItemType,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setBidLineItems(response.data);
      }
      return response;
    });
  };

  const createBidLineItem = async (data: IBidLineItemPayload) => {
    return stateManager.run(async () => {
      return homeService.bidLineItems.create({
        data,
        toastMessageConfig: {
          success: { text: `${data.name} was created successfully.` },
        },
      });
    });
  };

  const updateBidLineItem = async (
    id: string,
    data: Partial<IBidLineItemPayload>
  ) => {
    return stateManager.run(async () => {
      return homeService.bidLineItems.update({
        data: {
          ...data,
          id,
        },
        toastMessageConfig: {
          success: {
            text: `${data.name || "Bid line item"} was updated successfully.`,
          },
        },
      });
    });
  };

  const deleteBidLineItem = async (data: Partial<IBidLineItemResponse>) => {
    return stateManager.run(async () => {
      return homeService.bidLineItems.delete({
        data,
        toastMessageConfig: {
          success: {
            text: `${data.name || "Bid line item"} was deleted successfully.`,
          },
        },
      });
    });
  };

  return {
    bidLineItems,
    setBidLineItems,
    getBidLineItems,
    createBidLineItem,
    updateBidLineItem,
    deleteBidLineItem,
    isLoading: stateManager.isBusy(),
  };
};
